module.exports = __webpack_public_path__ + "static/img/page2-img3.20ccf68.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/page2-img3.png
// module id = WvXS
// module chunks = 0